module.exports = __webpack_public_path__ + "img/arrcouvHG-DNLTerm.1582d54c.png";